export const clearAppElement = () => {
	const appElem = document.getElementById("app")
	if (appElem) {
		appElem.innerHTML = ""
	}
}